import { useRef, useState } from "react";
import { useUploadImageMutation } from "../../store/appSlice";
import PdfFileImage from "../../assets/images/pdfFile.png";
import { isEmpty } from "lodash";
import { Image } from "antd";

function PdfUploadingComponent({imageFile,setFile}){
    const[fileName,setFileName]=useState("")
    const [uploadImage] = useUploadImageMutation();
    const ref=useRef()

    const handleFileChange = (event) => {
        const fileObj = event.target.files && event.target.files[0];
        if (!fileObj) {
          return;
        }
      
        let formData = new FormData();
        formData.append("file", fileObj);
    
        uploadImage(formData) 
          .unwrap()
          .then((data) => {
            setFileName(fileObj?.name??'')
            setFile(data?.url)
    
          })
          .catch((err) => {});
      };

    return(
      <div>
        <div
        style={{width:90,height:90,border:'0.4px solid black',paddingTop: isEmpty(imageFile) ? 28 : 0,paddingBottom: isEmpty(imageFile) ? 28 : 0,borderRadius:10,marginTop:20,marginBottom:20}}
        onClick={()=>ref?.current?.click()}
        >
          {
            !isEmpty(imageFile)&&
      <Image src={PdfFileImage} style={{height:'90px',width:'90px',resize:'contain',marginBottom:20}} preview={false} onClick={handleFileChange}/>   }
      
      <input
          ref={ref}
        id="fileInput"
        type="file"
        accept="application/pdf"
        style={{display:'none'}}
        onChange={handleFileChange}
      /> 
      {isEmpty(imageFile) &&<text style={{textAlign:'center',fontSize:10,marginLeft:6,fontWeight:'bold'}}>Upload Pdf here</text>}
      </div>
      <h5>{fileName}</h5>
      </div>
    )
}

export default PdfUploadingComponent